<template>
  <div
    id="fee_deposit"
    v-loading.fullscreen.lock="pageLoading"
  >
    <div class="main">
      <div class="rule">
        <div class="title">
          入帳規則
        </div>
        <div class="itemWrap">
          <div class="item">
            1.代收各通路管理費費用款項將於每週三代收款項至社區指定帳戶，如匯款日遇例假日、特定假日或天災地變等不可抗力事件則得順延至次一個銀行營業日辦理，屆時以系統公告為主。
          </div>
          <div class="item">
            2.各筆款項入帳時間，因各通路代收作業時間不同，詳情請見<a
              href="https://www.smartdaily.com.tw/management-fee-qa/"
              target="_blank"
              rel="noopener"
            >常見問題</a>。
          </div>
        </div>
      </div>
      <filter-frame
        :filter-form="depositFilter"
        @search="getList"
        @clear="getListDefault()"
      />
      <div class="title_bar">
        <div class="left" />
        <div class="right">
          <span>搜尋結果共計{{ depositData.length }}筆</span>
        </div>
      </div>
      <list-frame
        v-loading="loadingList"
        :list-form="depositList"
        :list-data="depositData"
      >
        <el-table-column
          slot="Operation"
          class-name="operation"
          width="130"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              @click="handleDownloadExcel(scope.row)"
            >
              下載
            </el-button>
          </template>
        </el-table-column>
      </list-frame>
    </div>
  </div>
</template>
<script>
import filterFrame from '@/components/FilterFrame'
import listFrame from '@/components/ListFrame'
const LastSixMonthRange = [dayjs().add(-6, 'month').format('YYYY-MM-DD'), dayjs().add(7, 'day').format('YYYY-MM-DD')]
export default {
  components: {
    'filter-frame': filterFrame,
    'list-frame': listFrame
  },
  data () {
    return {
      pageLoading: false,
      loadingList: false,
      filterCondition: null,
      depositFilter: [
        {
          label: '入帳起訖',
          name: 'EntryDate',
          type: 'date',
          value: LastSixMonthRange,
          pickerOptions: ['currentMonth', 'currentYear']
        }
      ],
      depositList: [
        {
          prop: 'EntryDate',
          label: '入帳日期',
          sortable: true
        },
        {
          prop: 'TotalPayAmount',
          label: '繳費總額',
          width: '150',
          align: 'right'
        },
        {
          prop: 'EntryCount',
          label: '繳費筆數',
          width: '120',
          align: 'right'
        },
        {
          prop: 'CollectionHandlingFee',
          label: '代收手續費',
          width: '150',
          align: 'right'
        },
        {
          prop: 'MoneyTransferHandlingFee',
          label: '匯款手續費',
          width: '100',
          align: 'right'
        },
        {
          prop: 'TotalEntryAmount',
          label: '撥款總額',
          width: '150',
          align: 'right'
        },
        {
          slot: 'Operation'
        }
      ],
      depositData: []
    }
  },
  mounted () {
    this.getListDefault()
  },
  methods: {
    getListDefault () {
      this.getList({
        EntryDate: LastSixMonthRange
      })
    },
    getList (condition) { // 取得繳費單列表
      this.loadingList = true
      if (condition) {
        this.filterCondition = _cloneDeep(condition)
      }
      const requestData = this.filterCondition
        ? Object.assign(
          {},
          this.filterCondition.EntryDate && { start: this.filterCondition.EntryDate[0] },
          this.filterCondition.EntryDate && { due: this.filterCondition.EntryDate[1] }
        )
        : null
      console.log(requestData)

      apiBillservice.Receipt.GetEntryReport(
        requestData
      ).then((res) => {
        console.log(res.data.Data)
        this.depositData = res.data.Data.map((e) => {
          e.EntryDate = this.$formatDate(e.EntryDate)
          e.TotalEntryAmount = e.TotalEntryAmount ? e.TotalEntryAmount.toLocaleString() : e.TotalEntryAmount
          e.TotalPayAmount = e.TotalPayAmount ? e.TotalPayAmount.toLocaleString() : e.TotalPayAmount
          return e
        })
        this.loadingList = false
      }).catch((err) => {
        this.$message({
          message: '取得入帳報表失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingList = false
      })
    },
    handleDownloadExcel (rowData) { // 下載excel
      this.pageLoading = true
      const requestData = {
        entryDate: rowData.EntryDate
      }
      const config = {
        responseType: 'blob' // important
      }
      apiBillservice.Receipt.GetEntryReportExport(
        requestData,
        config
      ).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('download',`${row.BillBulkName}_${this.getNowDate()}.xlsx`) //or any other extension
        link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace(/"/g, ''))}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.pageLoading = false
      }).catch((err) => {
        console.log(err)
        console.log(err.response)
        this.$message({
          message: '下載報表失敗，請稍後再試',
          type: 'warning'
        })
        this.pageLoading = false
      })
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_deposit
  text-align: center
  .main
    min-width: 900px
    color: $mainFontColor
    .rule
      display: flex
      justify-content: space-between
      align-items: flex-start
      padding: 20px 15px 10px
      text-align: left
      .title
        font-weight: bold
        font-size: map-get($fontSize,small)
        margin-bottom: 10px
        flex-basis: 150px
      .itemWrap
        flex: 1
        .item
          line-height: 1.3
          margin-bottom: 10px
          a
            cursor: pointer
            color: $mainColorDark
            text-decoration: underline
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 20px 0
      .right
        span
          margin: 0 20px
          color: $mainFontColor
          vertical-align: middle
</style>
